<div class="appNav">
  <div class="appNav__container container pl-0 pr-0">
    <div class="appNav__row row m-0" [class.withBtUpgrade]="showUpgradeToPremiumLine">
      <div class="appNav__leftColumn col-md-6 p-0">
        <span class="appNav__logo mr-4 mr-xl-5" fxHide.xs>
          <img style="width: 222px" [routerLink]="['/']"
               class="logo"
               src="assets/img/logo.png" alt="Wickedlist free adult personal classifieds" />
        </span>
        
        <a class="appNav__shortInfo pl-xl-3" routerLink="/">
          <span>AMERICA'S #1 DESTINATION FOR<br>FREE ADULT PERSONAL CLASSIFIEDS</span>
        </a>
      </div>
      <div class="appNav__rightColumn col-md-6 p-0">
        
        <button [routerLinkActiveOptions]="{ exact: true }" 
                [routerLinkActive]="['link-active']"
                [routerLink]="['/adv-create']" 
                class="appNav__btnsubmitAd color-reverse mr-3" 
                mat-flat-button 
                color="primary">
          <span class="d-inline-block pl-1">
            <i class="icons-add-ad"></i>
            Submit Ad (free)
          </span>
        </button>

        <button 
         class="appNav__btnConversations appNav__btnConversations--badgePositioned color-blue mr-3" 
         mat-flat-button color="primary" 
         routerLink="/conversations"
         *ngIf="mainService.userService.isAuthenticated()">
          <span [matBadgeHidden]="newMessageCount <= 0" matBadge="{{ newMessageCount }}" matBadgeColor="accent"
            matBadgeSize="small"><i class="icons-envelope"></i>&nbsp;Inbox</span>
        </button>

        <button (click)="mainService.showLogin()" 
                *ngIf="!mainService.userService.isAuthenticated()"
                class="appNav__btnsignIn  mr-3"
                mat-button>
          Sign In
        </button>

        <button *ngIf="!mainService.userService.isAuthenticated()" 
                [routerLinkActiveOptions]="{ exact: true }"
                [routerLinkActive]="['link-active']" 
                [routerLink]="['/register']"
                class="appNav__btnSignUp  mr-3" 
                mat-button>
          Sign Up
        </button>
        <button *ngIf="mainService.userService.isAuthenticated()" 
                [matMenuTriggerFor]="profileMenu"
                class="appNav__btnUser  mr-3"
                mat-stroked-button>
          <i class="icons-user" *ngIf="!ShowSpecialBadge"></i>
          <span class="btnUser__userName" *ngIf="mainService.userService.isAuthenticated()">
              &nbsp;<span>{{ this.mainService.userService.getUserEmail() }}</span>
          </span>
          <img class="btnUser__premiumIcon" src="/images/premium-icon.png" *ngIf="ShowSpecialBadge" />
        </button>

        <button *ngIf="showUpgradeToPremiumLine" 
                class="appNav__btnPremiumUpgrade" 
                routerLink="/compare-versions"
                mat-flat-button 
                color="primary">
          <strong>Upgrade</strong>
        </button>
       
        <mat-menu #profileMenu="matMenu" xPosition="after">
          <div>
            <div>
              <button (click)="logout()" class="appNav__btnLogout" mat-button>
                <span>Logout</span>
              </button>
            </div>
            <div *ngIf="enableSubscription">
              <button class="appNav__btnSubscription" mat-button routerLink="/subscription-information">
                <span>Subscription</span>
              </button>
            </div>
            <div>
              <button class="appNav__btnMyAds" mat-button routerLink="/my-ads">
                <span>My ads</span>
              </button>
            </div>
            <div>
              <button class="appNav__btnDeletAccount" mat-button (click)="showDeleteAccountModal()">
                <span>Delete account</span>
              </button>
            </div>
            <div>
              <button (click)="showAllNonDemoAds()" *ngIf="isAdminOrDemo" class="appNav__btnNonDemoAds">
                All non demo ads
              </button>
            </div>
          </div>
        </mat-menu>
      </div>
    </div>
  </div>
</div>
